import Vue from 'vue'
import VueMeta from 'vue-meta'
import store from '@/store'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})

function metaToOg(meta) {
  const item = {
    type: 'website',
    title: meta.title,
    description: meta.description,
    url: meta.url,
    image: meta.image,
    site_name: meta.author,
  }
  const result = []
  for (const key in item) {
    result.push({
      property: `og:${key}`,
      content: item[key],
    })
  }
  return result
}

function metaToTwitter(meta) {
  const item = {
    // card: 'summary',
    card: 'summary_large_image', // 'summary_large_image', 'summary', 'app', 'player'
    title: meta.title,
    description: meta.description,
    image: meta.image,
    domain: location.origin,
  }
  const result = []
  for (const key in item) {
    result.push({
      name: `twitter:${key}`,
      content: item[key],
    })
  }

  return result
}

function metaToDefaultMeta(meta) {
  const item = {
    description: meta.description,
    keywords: meta.keywords,
    author: meta.author,
  }
  const result = []
  for (const key in item) {
    result.push({
      name: key,
      content: item[key],
    })
  }

  return result
}

function othersMeta(meta) {
  const item = {
    'apple-mobile-web-app-title': meta.author,
    'apple-mobile-web-app-capable': 'yes',
    'mobile-web-app-capable': 'yes',
    'theme-color': '#6D6AFF',
    'msapplication-TileColor': '#6D6AFF',
    'msapplication-TileImage': '',
  }

  const result = []
  for (const key in item) {
    result.push({
      name: key,
      content: item[key],
    })
  }

  return result
}

function othersLink(meta) {
  return [
    {
      rel: 'canonical',
      href: location.origin,
    },
    // {
    //   rel: 'apple-touch-icon-precomposed',
    //   href: null
    // }, {
    //   rel: 'apple-touch-icon',
    //   href: null
    // }, {
    //   rel: 'icon',
    //   type: 'image/png',
    //   href: null,
    //   sizes: '500x500'
    // }
  ]
}

/**
 *
 * @param {*} vm 현재페이지 created의 this
 * @param {*} obj defaultMeta에 있는 항목과 비슷한 형식의 값
 */
global._meta = async (obj) => {
  const meta = Object.assign(
    {
      author: '바이나우',
      title: '어제 매출 오늘 받아보는 선정산 서비스 바이나우',
      titlesDefault: '바이나우',
      // titles: [],
      description:
        '묶여있는 플랫폼 매출 오늘 받아보세요! 365일 24시간 언제든 5분내로 정산금을 먼저 지급해드립니다. 전과정 비대면 온라인 계약으로 편리한 패션 플랫폼 선정산 서비스',
      keywords:
        '선정산, 간편계약, 플랫폼정산, 정산금지연, 온라인, 선정산, 온라인선정산, 정산금, 동대문사입, 동대문, 의류, 동대문 도매시장, 사입, 도매시장사입, 의류사입, 에이블리정산, 에이블리, 브랜디, 브랜디정산, 하이버, 하이버정산, 지그재그, 지그재그정산, 신상마켓, 신상마켓사입, 남대문, 남대문사입, 중국사입, 데일리페이, 올라, 쿠팡, 스마트스토어, 쇼핑몰선정산, 오픈마켓선정산, 셀러론, 선정산업체, 빠른정산, 무신사선정산, 매출선정산, 셀러대출, 당일정산',
      type: null,
      url: null,
      image: 'https://ddsjbjzjtwza3.cloudfront.net/thumbnail/thumbnail_250214.png',
      meta: [],
      link: [],
    },
    { url: location.href },
    obj,
  )

  // const metaForLinkShare = {
  //   ...meta,
  //   title: '바이나우 BUYNOW',
  //   description: '온라인 셀러라면 2배 한도 선정산',
  // }

  if (meta.titles) {
    let title = ''
    meta.titles.unshift(meta.titlesDefault)
    meta.titles.reverse()

    for (var i = 0; i < meta.titles.length; i++) {
      title += meta.titles[i]
      if (i !== meta.titles.length - 1) {
        title += ' | '
      }
    }
    delete meta.titles
    meta.title = title
  }

  if (meta.image.startsWith('http') === false) {
    meta.image = `${location.protocol}//${location.host}${meta.image}`
  }

  // og
  let og = meta
  if (meta.og) {
    og = {
      ...meta,
      ...meta.og,
    }
  }

  meta.meta = meta.meta
    .concat(metaToOg(og)) // og
    .concat(metaToTwitter(meta)) // twitter
    .concat(metaToDefaultMeta(meta)) // default
    .concat(othersMeta(meta)) // others

  meta.link = meta.link.concat(othersLink(meta))

  store.dispatch('meta/set', meta)

  return meta
}
